/*
 * @Author: songyzh
 * @Date: 2020-07-20 17:31:57
 * @LastEditors: songyzh
 * @LastEditTime: 2020-08-20 11:14:42
 */
import Vue from 'vue';
import ViewUI from 'view-design';
import App from './app.vue';
import router from './router';

import '@/components';
import 'view-design/dist/styles/iview.css';
import './styles/index.scss';

import initConfig from './init-app-config';

Vue.use(ViewUI);
Vue.config.productionTip = false;

function renderPage() {
  new Vue({
    router,
    render: (h) => h(App),
  }).$mount('#app');
}

async function init() {
  await initConfig();
  renderPage();
}

init();
